import { reset } from 'patronum/reset'
import { $isReadyToSubmit } from './form'
import { $currentStepGravy, closeGravyPopup } from './model'

reset({
  clock: [closeGravyPopup, $currentStepGravy],
  target: $isReadyToSubmit,
})
